<template>
    <div
            :tabindex="tabindex"
            :class="{ 'multiselect--active': isOpen, 'multiselect--disabled': disabled, 'multiselect--above': isAbove }"
            @focus="activate()"
            @blur="searchable ? false : deactivate()"
            @keydown.self.down.prevent="pointerForward()"
            @keydown.self.up.prevent="pointerBackward()"
            @keydown.enter.tab.stop.self="addPointerElement($event)"
            @keyup.esc="deactivate()"
            class="multiselect">
        <slot name="caret" :toggle="toggle">
            <div @mousedown.prevent.stop="toggle()" class="multiselect__select"></div>
        </slot>
        <slot name="clear" :search="search"></slot>
        <div ref="tags" class="multiselect__tags">
            <div class="multiselect__tags-wrap" v-show="visibleValues.length > 0">
                <template v-for="option of visibleValues" @mousedown.prevent>
                    <slot name="tag" :option="option" :search="search" :remove="removeElement">
              <span class="multiselect__tag">
                <span v-text="getOptionLabel(option)"></span>
                <i aria-hidden="true" tabindex="1" @keydown.enter.prevent="removeElement(option)"  @mousedown.prevent="removeElement(option)" class="multiselect__tag-icon"></i>
              </span>
                    </slot>
                </template>
            </div>
            <template v-if="internalValue && internalValue.length > limit">
                <slot name="limit">
                    <strong class="multiselect__strong" v-text="limitText(internalValue.length - limit)"/>
                </slot>
            </template>
            <transition name="multiselect__loading">
                <slot name="loading">
                    <div v-show="loading" class="multiselect__spinner"/>
                </slot>
            </transition>
            <input
                    ref="search"
                    v-show="isOpen && searchable"
                    :name="name"
                    :id="id"
                    type="text"
                    autocomplete="off"
                    :placeholder="placeholder"
                    :style="inputStyle"
                    :value="search"
                    :disabled="disabled"
                    :tabindex="tabindex"
                    @input="updateSearch($event.target.value)"
                    @focus.prevent="activate()"
                    @blur.prevent="deactivate()"
                    @keyup.esc="deactivate()"
                    @keydown.down.prevent="pointerForward()"
                    @keydown.up.prevent="pointerBackward()"
                    @keydown.enter.prevent.stop.self="addPointerElement($event)"
                    @keydown.delete.stop="removeLastElement()"
                    class="multiselect__input"/>
            <span
                    v-if="isSingleLabelVisible"
                    class="multiselect__single"
                    @mousedown.prevent="toggle">
          <slot name="singleLabel" :option="singleValue">
            <template>{{ currentOptionLabel }}</template>
          </slot>
        </span>
            <span v-if="isPlaceholderVisible" @mousedown.prevent="toggle">
          <slot name="placeholder">
            <span class="multiselect__single">
              {{ placeholder }}
            </span>
          </slot>
        </span>
        </div>
        <transition name="multiselect">
            <div
                    class="multiselect__content-wrapper"
                    v-show="isOpen"
                    @focus="activate"
                    @mousedown.prevent
                    :style="{ maxHeight: optimizedHeight + 'px' }"
                    ref="list">
                <ul class="multiselect__content" :style="contentStyle">
                    <slot name="beforeList"></slot>
                    <li v-if="multiple && max === internalValue.length">
              <span class="multiselect__option">
                <slot name="maxElements">Maximum of {{ max }} options selected. First remove a selected option to select another.</slot>
              </span>
                    </li>
                    <template v-if="!max || internalValue.length < max">
                        <li class="multiselect__element" v-for="(option, index) of filteredOptions" :key="index">
                <span
                        v-if="!(option && (option.$isLabel || option.$isDisabled))"
                        :class="optionHighlight(index, option)"
                        @click.stop="select(option)"
                        @mouseenter.self="pointerSet(index)"
                        :data-select="option && option.isTag ? tagPlaceholder : selectLabelText"
                        :data-selected="selectedLabelText"
                        :data-deselect="deselectLabelText"
                        class="multiselect__option">
                    <slot name="option" :option="option" :search="search">
                      <span>{{ getOptionLabel(option) }}</span>
                    </slot>
                </span>
                            <span
                                    v-if="option && (option.$isLabel || option.$isDisabled)"
                                    :data-select="groupSelect && selectGroupLabelText"
                                    :data-deselect="groupSelect && deselectGroupLabelText"
                                    :class="groupHighlight(index, option)"
                                    @mouseenter.self="groupSelect && pointerSet(index)"
                                    @mousedown.prevent="selectGroup(option)"
                                    class="multiselect__option">
                    <slot name="option" :option="option" :search="search">
                      <span>{{ getOptionLabel(option) }}</span>
                    </slot>
                </span>
                        </li>
                    </template>
                    <li v-show="showNoResults && (filteredOptions.length === 0 && search && !loading)">
              <span class="multiselect__option">
                <slot name="noResult">No elements found. Consider changing the search query.</slot>
              </span>
                    </li>
                    <slot name="afterList"></slot>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        extends: Multiselect,
        name: "vue-multiselect",
        props: {
            limitText: {
                type: Function,
                default: function (count) {
                    return `${this.placeholder} (${count})`
                }
            },

        },
        computed: {

            isSingleLabelVisible () {
                return this.singleValue &&
                    (!this.isOpen || !this.searchable) &&
                    (!this.visibleValues.length && this.limit > 0)
            },
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Select/VueMultiselectExtended.vue